export default __webpack_public_path__ + "static/media/640_business04-es-web.2750c7ae.png";